<div class="d-flex flex-row">
  <ng-select
    [items]="patientAttachmentOptions"
    [multiple]="false"
    [(ngModel)]="selectedAttachmentId"
    (change)="onSelectionChange()"
    bindValue="id"
    name="selectedAttachment"
    placeholder="Select File"
    class="documents-select phi"
    groupBy="markedAsInvalid"
    [clearable]="false"
    >

    <ng-template ng-optgroup-tmp let-item="item">
      @if (item.markedAsInvalid) {
        <span>Invalid</span>
      }
      @if (!item.markedAsInvalid) {
        <span>Valid</span>
      }
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      {{ item.patientAttachment | patientAttachmentDisplayName }} -
      {{ item.patientAttachment.createdAt | date: 'M/d/yyyy h:mm a' }}

      <app-patient-attachment-duplicate [patientAttachment]="item.patientAttachment" />
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      {{ item.patientAttachment | patientAttachmentDisplayName }} -
      {{ item.patientAttachment.createdAt | date: 'M/d/yyyy h:mm a' }}

      @if (item.verified) {
        <fa-icon [icon]="['fas', 'check']" class="check" />
      }

      <app-patient-attachment-duplicate [patientAttachment]="item.patientAttachment" />
    </ng-template>
  </ng-select>

  @if (selectedAttachment?.id && selectedAttachment.standardConsultNote) {
    <span class="align-self-center ms-2">
      <a routerLink="/capture-admin/consult-notes/{{ selectedAttachment.id }}"
        target="_blank"
        title="Open consult note in new tab">
        <fa-icon [icon]="['fas', 'external-link-alt']" />
      </a>
    </span>
  }
</div>
